var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { parseIsoDate, toIsoDateString } from "./isoDate";
var CS_MONTHS = [
    "leden",
    "únor",
    "březen",
    "duben",
    "květen",
    "červen",
    "červenec",
    "srpen",
    "září",
    "říjen",
    "listopad",
    "prosinec",
];
var CS_WEEKDAYS_SHORT = ["ne", "po", "út", "st", "čt", "pá", "so"];
export function formatDateLabel(iso, tier) {
    if (!iso)
        return "";
    var date = parseIsoDate(iso);
    switch (tier) {
        case 1:
            return CS_MONTHS[date.getMonth()];
        case 2:
            return "".concat(date.getDate(), ".").concat(date.getMonth() + 1, ".");
        case 3:
            return "".concat(CS_WEEKDAYS_SHORT[date.getDay()], " ").concat(date.getDate(), ".");
        default:
            return "";
    }
}
export function computeMergedEndDates(issues) {
    var result = new Map();
    issues.forEach(function (iss) {
        var _a, _b, _c;
        var mergeCount = (_b = (_a = iss.mergedIssueNumbers) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 1;
        if (mergeCount <= 1 || !iss.expectedDate)
            return;
        var memberDates = (_c = iss.mergedIssueDates) !== null && _c !== void 0 ? _c : [];
        if (memberDates.length > 0) {
            var sortedDates = __spreadArray([], memberDates, true).sort();
            result.set(iss.id, sortedDates[sortedDates.length - 1]);
            return;
        }
        // Fallback for older backends without mergedIssueDates: primary.date + (mergeCount-1) calendar days.
        var start = parseIsoDate(iss.expectedDate);
        var end = new Date(start);
        end.setDate(end.getDate() + mergeCount - 1);
        result.set(iss.id, toIsoDateString(end));
    });
    return result;
}
export function formatDateRange(startIso, endIso, tier) {
    if (!startIso)
        return "";
    if (!endIso || startIso === endIso)
        return formatDateLabel(startIso, tier);
    return "".concat(formatDateLabel(startIso, tier), " - ").concat(formatDateLabel(endIso, tier));
}
